/* línkè · 他的工作室数据层（2026-07-21）====================
   GET /api/studio：把他默默做的事（小本本/共读/喂猫/记忆桶）
   按「家具」归拢的一扇只读的窗。她被请进来参观，不写。
   ============================================================ */

export async function loadStudio() {
  const res = await fetch('/api/studio', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}
